<div class="middle-holder">
  <div class="middle">
    <spb-logo [onlyLogoLink]="true" [routePath]="[mainPath]"/>
    @if (configService.currentUser() && configService.isAdmin()) {
      <spb-toggle-button/>

      <div class="middle">
        <div class="menu">
          <div [routerLink]="[mainPath]">
            Rådgivning
            @if (scenario) {
              - {{ scenario }}
            }
          </div>
          <button [routerLink]="[customerPath]" (click)="dataService.reset()"
                  matButton="outlined">
            Pågående Rådgivningar
          </button>
          <button (click)="reset()" matButton="outlined">
            Ny kund
          </button>
          <button (click)="dataService.save().subscribe()"
                  [disabled]="controlService.locked() ||
                                 ((controlService.canSave$ | async) !== true)"
                  matButton="filled">
            Spara
          </button>
        </div>
        @if (testService.showTestData) {
          <spb-test/>
        }
        <div class="spb-filler"></div>
        <div>
          <span>{{ configService.currentUser()?.name }}</span>
        </div>
        <div class="middle-menu">
          <div class="menu"></div>
          <div class="filler"></div>
          <button [matMenuTriggerFor]="menu" mat-icon-button>
            <mat-icon>menu</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button (click)="configService.reset()" mat-menu-item>
              Logga ut
            </button>
            <button
                (click)="testService.showTestData = !testService.showTestData"
                mat-menu-item>
              @if (!testService.showTestData) {
                <mat-icon>visibility</mat-icon>
              } @else {
                <mat-icon>visibility_off</mat-icon>
              }
              Test
            </button>
          </mat-menu>
        </div>
      </div>
    }
  </div>
</div>